import TopNav from '../components/molecules/topNav'
import ChatContainer from '../components/organisms/chatContainer'
import SideBar from '../components/organisms/sideBar'
import io from 'socket.io-client'
import { useEffect, useState } from 'react'

const Chat = () => {
  const [socket, setSocket] = useState({ nsp: 'null' })

  useEffect(() => {
    const newSocket = io(process.env.REACT_APP_SOCKET_LINK, {
      withCredentials: true,
    })
    setSocket(newSocket)
    return () => newSocket.close()
  }, [setSocket])

  const localStorageData = JSON.parse(localStorage.getItem('user'))

  // Detect user changes in localStorage and send to backend
  useEffect(() => {
    if (socket.nsp !== 'null') {
      // console.log('User change emitted :   ' + localStorageData['username'] + '\n\n')
      socket.emit('User changed', { nick: localStorageData['username'] })
    }
  }, [socket, localStorageData])

  useEffect(() => {
    if (!socket || typeof socket.on !== 'function') return
    const handleRedirect = (data) => {
      if (data.reason === 'banned') {
        window.location.href = data.url + '?banned=true'
      } else {
        window.location.href = data.url
      }
    }

    socket.on('redirect', handleRedirect)
    return () => socket.off('redirect', handleRedirect)
  }, [socket])

  return (
    <div>
      <TopNav />
      <div className="flex h-full overflow-x-clip ">
        <div className="grow p-8 pb-0 mt-16">
          <ChatContainer socket={socket} />
        </div>
        <SideBar socket={socket} />
      </div>
    </div>
  )
}

export default Chat
